module.exports = __webpack_public_path__ + "static/media/icon_paper_plane_bold.9c201a27.svg";